import React from "react";
import { Link } from "react-router-dom";
import { Socials } from "../home";

const DisclosureOfMaterialInformation = () => {
  return (
    <div className="min-h-screen relative overflow-hidden mt-20">
      <div className="container mx-auto px-4 py-16 relative z-10">
        <h1 className="text-4xl md:text-5xl font-bold text-white mb-8 text-center animate-fade-in">
          Disclosure of Material Information
        </h1>

        <div
          className="max-w-4xl mx-auto text-white/80 space-y-6 text-lg animate-fade-in"
          style={{ animationDelay: "0.3s" }}
        >
          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            Purpose
          </h2>
          <p>
            This document outlines our commitment to transparency and disclosure
            of material information that may affect our users' trading decisions
            and platform usage.
          </p>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            What Constitutes Material Information
          </h2>
          <p>Material information includes, but is not limited to:</p>
          <ul className="list-disc list-inside space-y-3">
            <li>Significant changes to platform features or services</li>
            <li>Updates to pricing or subscription terms</li>
            <li>Modifications to trading rules or restrictions</li>
            <li>Changes in regulatory compliance requirements</li>
            <li>System maintenance or technical issues</li>
            <li>Security incidents or data breaches</li>
          </ul>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            How We Disclose Information
          </h2>
          <p>We communicate material information through:</p>
          <ul className="list-disc list-inside space-y-3">
            <li>In-platform notifications</li>
            <li>Email communications</li>
            <li>Official announcements on our website</li>
            <li>Updates to relevant documentation</li>
          </ul>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            Timing of Disclosures
          </h2>
          <p>We commit to:</p>
          <ul className="list-disc list-inside space-y-3">
            <li>Disclosing material information promptly</li>
            <li>Providing advance notice when possible</li>
            <li>Ensuring information is clear and accessible</li>
            <li>Maintaining transparency in our communications</li>
          </ul>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            User Responsibilities
          </h2>
          <p>Users should:</p>
          <ul className="list-disc list-inside space-y-3">
            <li>Regularly check for platform updates</li>
            <li>Maintain current contact information</li>
            <li>Review all communications from us</li>
            <li>Stay informed about changes that may affect their trading</li>
          </ul>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            Contact Information
          </h2>
          <p>
            For questions about material information or disclosures, please
            contact our support team through:
          </p>
          <ul className="list-disc list-inside space-y-3">
            <li>Email support</li>
            <li>In-platform chat</li>
            <li>Customer service hotline</li>
          </ul>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            Updates to This Policy
          </h2>
          <p>
            We may update this disclosure policy as needed to ensure continued
            transparency and compliance with regulatory requirements.
          </p>

          <div className="intellectia-card p-8 mt-12 text-center">
            <h3 className="text-xl font-semibold mb-4">Stay Informed</h3>
            <p className="mb-6">
              Follow us on social media to receive the latest updates and
              important announcements.
            </p>
            < Socials />

          </div>
        </div>
      </div>
    </div>
  );
};

export default DisclosureOfMaterialInformation;
